<template>
  <div :key="type">
    <div v-if="!getOrderLoading" class="application">
      <!-- Заявка -->
      <section class="info">
        <h1>
          Заявка {{ isRead && infoData.number ? `№ ${infoData.number}` : "" }}
          <svgicon
            v-if="osrIconName"
            :icon="osrIconName"
            :class="[
              'osr-icon',
              {
                'osr-icon-accept': osrIconName === 'osr-accept',
                'osr-icon-reject': osrIconName === 'osr-reject',
              },
            ]"
          />
        </h1>

        <Form
          scrollWhenInvalid
          class="info_form"
          v-model="infoData"
          ref="infoForm"
        >
          <VSwitch
            v-if="showOsrSwitch"
            :disabled="!isCreate"
            v-model="infoData.isOsrApprovable"
            label="Создать ОСР"
          />
          <VInput
            v-if="!isRead"
            disabled
            name="number"
            placeholder="№"
            width="105px"
            :maskRegex="/^\d+$/"
          />

          <!-- Связанные заявки -->
          <OrderRelated
            v-if="ordersRelated.length"
            :orders="ordersRelated"
            :type-order-related="orderRelatedType"
            @clickOrder="handleOrderClick"
          />

          <VInput
            name="createDate"
            type="date"
            :disabled="!isRead"
            :value="!isRead && new Date() | simpleDate"
            label="Дата создания:"
            placeholder="По дате создания заявки"
            :readonly="isRead"
          />
          <VSelect
            label="Статус:"
            placeholder="Статус заявки:"
            name="status"
            readonly
            hidden
            :items="statusOptions"
            disabled
            :value="isCreate ? { id: 1, name: 'Новая' } : null"
            required
          >
            <template slot="item" slot-scope="{ item }">
              <VStatus :status="item" />
            </template>
          </VSelect>

          <hr v-if="isRead" />

          <VSelect
            label="Пользователь:"
            placeholder="ФИО пользователя"
            name="userFIO"
            :items="users"
            :readonly="isRead"
            :value="isCreate ? activeUser : null"
            disabled
          >
            <template slot="item" slot-scope="{ item }">
              <AccountBadge
                fullUserinfo
                :user="item"
                :style="isRead ? 'margin-top: 14px' : null"
              />
            </template>
          </VSelect>

          <div style="width: 100%">
            <div
              v-if="isRead"
              class="input__label"
              style="display: flex; align-items: center; gap: 8px"
            >
              Пассажиры:
              <Button
                v-if="infoData.passengersFIO && infoData.passengersFIO.length"
                iconWidth="14px"
                icon="open-view"
                width="14px"
                class="open-view-icon"
                @click="passengersDialog = true"
              />
            </div>
            <button
              v-else
              class="user__add-button"
              @click.capture.prevent="addPassanger"
            >
              ФИО пассажиров
              <Button
                icon="add"
                height="46px"
                width="46px"
                iconWidth="24px"
                class="user__add-button-icon"
                :disabled="isOrderReturn"
              />
            </button>
            <div class="scroll info_form-users">
              <div
                v-for="(item, index) in infoData.passengersFIO"
                :key="index + 'pas'"
                class="user__item"
              >
                <AccountBadge
                  selecteble
                  fullUserinfo
                  :user="item"
                  :removable="!isRead"
                />
                <Button
                  @click="openDeletePassenger(index)"
                  icon="clear"
                  iconWidth="17px"
                  class="user__item-icon"
                  v-if="!isRead && !isOrderReturn"
                />
              </div>
            </div>
            <div v-if="isRead && !infoData.passengersFIO.length">-</div>
          </div>

          <VSelect
            label="Руководитель:"
            placeholder="ФИО руководителя"
            name="leadFIO"
            :readonly="isRead"
            :value="leadActiveUser"
            :items="leadersExist"
            searchSelect
            leader
            required
            :disabled="isOrderReturn"
          >
            <template slot="item" slot-scope="{ item }">
              <AccountBadge
                :user="item"
                fullUserinfo
                :style="isRead ? 'margin-top: 19px' : null"
              />
            </template>
          </VSelect>
          <VSelect
            label="Логист:"
            placeholder="ФИО логиста"
            name="logistFIO"
            :readonly="isRead"
            :value="
              isCreate && isLogist
                ? logisticians.find((user) => user.id === activeUser.id)
                : null
            "
            :items="logisticiansExist"
            :disabled="
              (!isLogist && !isAdmin && !isSuperAdmin) || isOrderReturn
            "
            searchSelect
            logist
          >
            <template slot="item" slot-scope="{ item }">
              <AccountBadge
                :user="item"
                fullUserinfo
                :style="isRead ? 'margin-top: 19px' : null"
              />
            </template>
          </VSelect>

          <hr v-if="!isRead" />

          <VInput
            v-show="!isRead"
            v-model="comment"
            type="textarea"
            label="Комментарий:"
            placeholder="Комментарий"
            :readonly="isRead"
          />
        </Form>
      </section>

      <div class="content">
        <div class="content__control">
          <span
            class="content__item"
            :class="{ active: !isCommentsActive }"
            @click="isCommentsActive = false"
            >Информация о маршруте</span
          >
          <span
            class="content__item"
            :class="{ active: isCommentsActive }"
            @click="isCommentsActive = true"
            >Комментарии</span
          >
          <div v-if="isRead" class="content__edit">
            <Button
              width="36px"
              height="36px"
              icon="sortDown"
              class="btn-outline-primary"
              @click="historyDialog = true"
              :loading="historyLoading"
              dark
            />
            <Button
              @click="$router.push({ params: { type: 'edit' } })"
              width="36px"
              height="36px"
              icon="edit"
              class="btn-primary"
              style="border-top-right-radius: 0; border-bottom-right-radius: 0"
              :disabled="
                (!isAdmin &&
                  !isSuperAdmin &&
                  !isLogist &&
                  !(
                    infoData.status.id === 1 ||
                    infoData.status.id === 6 ||
                    infoData.status.id === 7
                  )) ||
                infoData.status.id === 3
              "
            />
          </div>
        </div>

        <!-- Маршрут -->
        <section class="direction" v-show="!isCommentsActive">
          <div class="direction__complexity">
            <h3>Сложность маршрута</h3>

            <div v-if="!isRead" class="direction__complexity-form">
              <span style="display: flex; align-items: center">
                <Checkbox
                  label="В одну сторону"
                  class="form__checkbox"
                  :passive="oneWay"
                  v-model="oneWay"
                />
                <Checkbox
                  label="Туда и обратно"
                  class="form__checkbox"
                  :passive="roundtrip"
                  v-model="roundtrip"
                  @click.native.capture="autocomplete()"
                />
              </span>
              <VSwitch v-model="withTransfer" label="С пересадкой" />
            </div>

            <div v-else class="direction__complexity-form">
              <div v-if="oneWay" class="complexity__read-item">
                В одну сторону
              </div>
              <div v-else class="complexity__read-item">Туда и обратно</div>
              <div v-if="withTransfer" class="complexity__read-item">
                С пересадкой
              </div>
            </div>
          </div>

          <hr style="margin: 23px -28px 0" />

          <OrderRelatedAccordion v-if="ordersRelatedAccordion.length">
            <template v-slot:title>
              <div class="accordion-order__title">
                <svg
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.85314 1.86057L1.5 0L0 5.5H5.5L4.02931 3.47781C4.8599 2.86333 5.88754 2.49999 7.00004 2.49999C9.76147 2.49999 12 4.73857 12 7.49999C12 10.2614 9.76147 12.5 7.00004 12.5C4.96299 12.5 3.21045 11.2818 2.43118 9.53419L0.605225 10.3472C1.24475 11.7836 2.34925 12.9628 3.74074 13.6949C5.13223 14.427 6.72969 14.6693 8.27569 14.3828C9.82169 14.0963 11.2262 13.2976 12.2629 12.1154C13.2996 10.9333 13.9082 9.43653 13.9905 7.86636C14.0727 6.29618 13.624 4.74402 12.7165 3.45999C11.8091 2.17595 10.4957 1.23483 8.98815 0.788264C7.48057 0.341697 5.86654 0.415695 4.40614 0.998334C3.85028 1.2201 3.32899 1.51064 2.85314 1.86057Z"
                    fill="white"
                  />
                </svg>
                <span>{{ orderRelatedAccordionTitle }}</span>
                <span class="accordion-order__count"
                  >({{ ordersRelatedAccordion.length }})</span
                >
              </div>
            </template>

            <template v-slot:content>
              <div class="accordion-order__content">
                <div
                  v-for="(order, idx_order) in ordersRelatedAccordion"
                  :key="idx_order + 'order'"
                >
                  <div
                    class="accordion-order__order"
                    role="link"
                    @click="handleOrderClick(order.history.order_id)"
                  >
                    <div class="accordion-order__number">
                      Заявка № {{ order.history.number }}
                    </div>
                    <div
                      v-for="(user, idx_user) in order.history.passengers"
                      :key="idx_user + 'user'"
                      class="accordion-order__user"
                    >
                      <AccountBadge
                        fullUserinfo
                        :user="user"
                        style="margin-bottom: 16px"
                        returnUser
                      />
                    </div>
                    <div
                      v-for="(rout, idx_rout) in order.history.paths"
                      :key="idx_rout + 'rout'"
                      class="accordion-order__rout"
                    >
                      <span class="direction__name">Откуда:</span>
                      <span class="direction__town">{{ rout.from }}</span>
                      <svg
                        class="direction__icon"
                        width="16"
                        height="15"
                        viewBox="0 0 16 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M-1.33364e-06 8.4375L12.17 8.4375L6.58 13.6781L8 15L16 7.5L8 2.54292e-07L6.59 1.32187L12.17 6.5625L-1.16972e-06 6.5625L-1.33364e-06 8.4375Z"
                          fill="#97B2C4"
                        />
                      </svg>
                      <span class="direction__name">Куда:</span>
                      <span class="direction__town">{{ rout.to }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </OrderRelatedAccordion>

          <div class="direction__content">
            <div
              class="direction__content-point"
              v-for="(way, wayIndex) in directions"
              :key="wayIndex + 'way'"
            >
              <h3>{{ way.title }}</h3>

              <Form
                :class="['point__item', { disabled: wayIndex === 1 && oneWay }]"
                ref="fromData"
                :name="wayIndex === 0 ? 'thereFrom' : 'backFrom'"
                :value="way.fromData"
                scrollWhenInvalid
              >
                <VInput name="sort" v-show="false" />
                <VInput
                  required
                  name="town"
                  label="Откуда:"
                  placeholder="Откуда"
                  :readonly="isRead"
                  :disabled="
                    (wayIndex === 1 && oneWay && !isRead) ||
                    disableRefundFields(way.fromData)
                  "
                />

                <VSelect
                  required
                  label="Статья расходов:"
                  placeholder="Статья расходов"
                  name="expense"
                  :items="expenseOptions"
                  item-text="name"
                  :readonly="isRead"
                  :disabled="
                    (wayIndex === 1 && oneWay && !isRead) ||
                    disableExchangeFields(way.fromData) ||
                    disableRefundFields(way.fromData)
                  "
                />

                <VSelect
                  required
                  :readonly="isRead"
                  label="Вид транспорта:"
                  placeholder="Вид транспорта"
                  name="transport"
                  item-text="name"
                  :width="isRead ? '45%' : '100%'"
                  :items="transportOptions"
                  :disabled="
                    (wayIndex === 1 && oneWay && !isRead) ||
                    disableExchangeFields(way.fromData) ||
                    disableRefundFields(way.fromData)
                  "
                  :class="isRead ? 'mobile__item' : ''"
                />
                <VSelect
                  required
                  :readonly="isRead"
                  label="Класс обслуживания:"
                  placeholder="Класс обслуживания"
                  name="service"
                  item-text="name"
                  :width="isRead ? '55%' : '100%'"
                  :items="priorityOptions"
                  :disabled="
                    (wayIndex === 1 && oneWay && !isRead) ||
                    disableExchangeFields(way.fromData) ||
                    disableRefundFields(way.fromData)
                  "
                  :class="isRead ? 'mobile__item' : ''"
                />
                <div
                  class="direction__date"
                  :class="isRead ? 'direction__date--mobile' : ''"
                >
                  <VInput
                    required
                    :readonly="isRead"
                    name="date"
                    type="date"
                    label="Дата отправления:"
                    placeholder="Дата отправления"
                    width="65%"
                    :disabled="
                      (wayIndex === 1 && oneWay && !isRead) ||
                      disableRefundFields(way.fromData)
                    "
                    :class="isRead ? 'mobile__item' : ''"
                  />
                  <VInput
                    :readonly="isRead"
                    name="time"
                    type="date"
                    label="Время:"
                    placeholder="Время"
                    width="32%"
                    onlyTime
                    :disabled="
                      (wayIndex === 1 && oneWay && !isRead) ||
                      disableRefundFields(way.fromData)
                    "
                    :class="isRead ? 'mobile__item' : ''"
                  />
                </div>
              </Form>

              <div v-if="withTransfer && !(isRead && !way.transfers.length)">
                <Button
                  @click="addTransfer(wayIndex)"
                  v-if="!isRead"
                  width="100%"
                  height="48px"
                  text="Добавить пересадку"
                  icon="add"
                  iconWidth="20px"
                  class="btn-outline-primary transfer__item"
                  :disabled="wayIndex === 1 && oneWay"
                />
                <Form
                  v-for="(transfer, index) in way.transfers"
                  :name="wayIndex === 0 ? `thereTransfers` : `backTransfers`"
                  :ref="wayIndex === 0 ? 'thereTransfers' : 'backTransfers'"
                  :key="index + way.title"
                  :value="transfer"
                  class="point__item transfer__item"
                  scrollWhenInvalid
                >
                  <Button
                    @click="opendeleteTransfer(index, wayIndex)"
                    icon="clear"
                    iconWidth="17px"
                    class="transfer__clear-icon"
                    v-if="!isRead"
                  />
                  <VInput name="sort" v-show="false" />
                  <p>
                    Пересадка
                    <span v-if="wayIndex === 0">"Туда" </span>
                    <span v-if="wayIndex === 1">"Обратно" </span>
                    <span>{{ index + 1 }}</span>
                  </p>
                  <VInput
                    required
                    name="town"
                    label="Через:"
                    placeholder="Через"
                    :readonly="isRead"
                  />

                  <VSelect
                    required
                    label="Статья расходов:"
                    placeholder="Статья расходов"
                    name="expense"
                    :items="expenseOptions"
                    item-text="name"
                    :readonly="isRead"
                    :disabled="
                      disableExchangeFields(transfer) ||
                      disableRefundFields(transfer)
                    "
                  />
                  <VSelect
                    required
                    :readonly="isRead"
                    label="Вид транспорта:"
                    placeholder="Вид транспорта"
                    name="transport"
                    item-text="name"
                    :width="isRead ? '45%' : '100%'"
                    :items="transportOptions"
                    :disabled="
                      disableExchangeFields(transfer) ||
                      disableRefundFields(transfer)
                    "
                  />
                  <VSelect
                    required
                    :readonly="isRead"
                    label="Класс обслуживания:"
                    placeholder="Класс обслуживания"
                    name="service"
                    item-text="name"
                    :width="isRead ? '55%' : '100%'"
                    :items="priorityOptions"
                    :disabled="
                      disableExchangeFields(transfer) ||
                      disableRefundFields(transfer)
                    "
                  />
                  <div
                    class="direction__date"
                    :class="isRead ? 'direction__date--mobile' : ''"
                  >
                    <VInput
                      required
                      :readonly="isRead"
                      name="date"
                      type="date"
                      label="Дата отправления:"
                      placeholder="Дата отправления"
                      width="65%"
                      :minDate="minDate(wayIndex, index)"
                    />
                    <VInput
                      :readonly="isRead"
                      name="time"
                      type="date"
                      label="Время:"
                      placeholder="Время"
                      width="32%"
                      onlyTime
                      :minDate="minDate(wayIndex, index, 'time')"
                    />
                  </div>
                </Form>
              </div>

              <Form
                :class="['point__item', { disabled: wayIndex === 1 && oneWay }]"
                style="height: auto"
                ref="toData"
                :name="wayIndex === 0 ? 'thereTo' : 'backTo'"
                :value="way.toData"
              >
                <VInput name="sort" v-show="false" />
                <VInput
                  required
                  name="town"
                  label="Куда:"
                  placeholder="Куда"
                  :readonly="isRead"
                  :disabled="
                    (wayIndex === 1 && oneWay && !isRead) ||
                    disableRefundFields(way.fromData)
                  "
                />
                <div
                  class="direction__date"
                  :class="isRead ? 'direction__date--mobile' : ''"
                >
                  <VInput
                    :readonly="isRead"
                    name="date"
                    type="date"
                    label="Дата прибытия:"
                    placeholder="Дата прибытия"
                    width="65%"
                    :minDate="minDate(wayIndex)"
                    :disabled="
                      (wayIndex === 1 && oneWay && !isRead) ||
                      disableRefundFields(way.fromData)
                    "
                  />
                  <VInput
                    :readonly="isRead"
                    name="time"
                    type="date"
                    label="Время:"
                    placeholder="Время"
                    width="32%"
                    onlyTime
                    :minDate="minDate(wayIndex, undefined, 'time')"
                    :disabled="
                      (wayIndex === 1 && oneWay && !isRead) ||
                      disableRefundFields(way.fromData)
                    "
                  />
                </div>
              </Form>
            </div>
          </div>
          <Button
            @click="changeStatus(5, 'complete')"
            :loading="loaders.complete"
            v-if="
              isRead &&
              (this.isLogist || this.isAdmin || this.isSuperAdmin) &&
              this.infoData.status.id === 4
            "
            width="228px"
            height="48px"
            text="Завершить заявку"
            class="btn-success"
            style="margin-top: 24px; margin-left: auto"
            :disabled="infoData.status && infoData.status.id === 7"
          />
        </section>

        <section class="comments" v-show="isCommentsActive">
          <div class="comments__empty" v-if="!isCommentsExists">
            Комментарии отсутствуют
          </div>
          <div class="comments__content" v-else>
            <div
              class="comment"
              v-for="item in infoData.comments"
              :key="item.id"
              style="position: relative"
              v-click-outside="() => (activeCommentMenu = null)"
            >
              <div class="comment__title">
                <AccountBadge shortUserinfo :user="item.user" />
                <div class="comment__date">{{ item.created_at_modified }}</div>
              </div>
              <div
                class="comment__status"
                v-if="
                  item.status.name.includes('Возврат') ||
                  item.status.name.includes('Обмен')
                "
              >
                <VStatus :status="item.status" />
              </div>
              <pre class="comment__message">{{ item.comment }}</pre>

              <div v-if="canEditComment" class="comment__actions">
                <Button
                  @click="toggleCommentActions(item.id)"
                  width="21px"
                  height="21px"
                  icon="options-dot"
                  iconWidth="20px"
                  class="buttons__actions"
                />

                <div
                  v-if="activeCommentMenu === item.id"
                  class="comment__actions-menu"
                >
                  <Button
                    text="Редактировать"
                    icon="edit"
                    width="100%"
                    iconWidth="15px"
                    class="buttons__item"
                    @click="openEditCommentModal(item)"
                  />

                  <Button
                    text="Удалить"
                    icon="delete"
                    width="100%"
                    iconWidth="15px"
                    class="comment__action-item"
                    @click="deleteCommentConfirm(item)"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- Кнопки -->
      <section class="panel">
        <Button
          v-if="!isRead"
          @click="isRead ? changeStatus(1) : checkOrders()"
          :loading="saveLoading"
          :disabled="pointsHistoryLoading"
          width="100%"
          height="48px"
          text="Сохранить"
          class="btn-primary"
        />
        <Button
          v-if="!isRead"
          @click="cancelEdit"
          width="100%"
          height="48px"
          text="Отменить"
          class="btn-secondary"
        />

        <Button
          v-for="(item, index) in buttons"
          :key="item.title + index"
          v-show="item.show"
          @click="item.event"
          :loading="loaders[item.loading]"
          width="100%"
          height="48px"
          :text="item.title"
          class="btn-outline-primary"
          dark
        />
        <VSwitch
          v-if="!isRead && (this.isLogist || this.isAdmin)"
          v-model="isControl"
          :disabled="infoData.isControl"
          label="Контроль СВП"
        />
        <VSwitch
          v-if="orderId && !isRead && (this.isLogist || this.isAdmin)"
          v-model="unviewed"
          label="Не просмотрена"
        />
      </section>
    </div>

    <Preloader v-else />

    <!-- oбмен/возврат -->
    <Modal
      v-if="commentDialog.isActive"
      @close="commentDialog.isActive = false"
      width="500px"
    >
      <h2 style="margin-bottom: 24px; text-align: center">
        {{ commentDialog.title }}
      </h2>

      <Form v-model="returnDate" @request="commentDialog.submit">
        <VSelect
          placeholder="Причина"
          name="returnReason"
          :items="returnReasons"
          @change="selectReturnReason"
          style="margin-bottom: 24px"
        >
          <template slot="item" slot-scope="{ item }">
            <span>{{ item.name }}</span>
          </template>
        </VSelect>
        <VSelect
          placeholder="Пассажиры"
          required
          name="passengersFIO"
          :items="infoData.passengersFIO"
          :value="passengerReturn"
          @change="selectPassengerReturn"
          withCheckbox
          multiple
          style="margin-bottom: 24px"
          class="return_pas"
          multiModels
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge
              :user="item"
              fullUserinfo
              :style="isRead ? 'margin-top: 19px' : null"
            />
          </template>
        </VSelect>
        <VSelect
          placeholder="Маршруты"
          required
          name="routs"
          :items="getRouts"
          :value="routsReturn"
          @change="selectRoutsReturn"
          withCheckbox
          multiple
          style="margin-bottom: 24px"
        >
          <template slot="item" slot-scope="{ item }">
            <span>{{ item.name }}</span>
          </template>
        </VSelect>
        <VSelect
          placeholder="Pуководитель"
          name="leadFIO"
          :value="leadReturn"
          :items="leadersExist"
          searchSelect
          leader
          required
          style="margin-bottom: 24px"
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge
              :user="item"
              fullUserinfo
              :style="isRead ? 'margin-top: 19px' : null"
            />
          </template>
        </VSelect>
        <VInput
          v-model="reasonComment"
          type="textarea"
          placeholder="Комментарий"
          style="margin-bottom: 24px"
        />
        <Button
          :loading="reasonCommentLoading"
          width="100%"
          height="48px"
          text="Отправить"
          class="btn-primary"
          style="margin-bottom: 16px"
        />
        <Button
          width="100%"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          @click.native.prevent="commentDialog.isActive = false"
        />
      </Form>
    </Modal>

    <Modal v-if="isError" @close="isError = false" width="544px" height="174px">
      <h2 class="center">Заполните маршрут "Туда" полностью</h2>
    </Modal>

    <HasPasOrderModal
      v-if="isHasTicket"
      @close="isHasTicket = false"
      :items="hasOrders"
      :loading="saveLoading"
      @save="saveOrder()"
    />

    <NoVipModal
      v-if="isNoVip"
      @close="isNoVip = false"
      text="Один или несколько пассажиров не могут использовать повышенный класс обслуживания"
      :isSave="this.isLogist || this.isSuperAdmin"
      :loading="saveLoading"
      @save="saveOrder()"
    />

    <!-- Добавление пассажиров -->
    <AddPassengersModal
      v-if="addPassengerDialog"
      @close="addPassengerDialog = false"
      @add="(data) => infoData.passengersFIO.push(data)"
      :usersWithFIO="trimUsersWithFIO"
    />

    <!-- Печать -->
    <SealModal
      v-if="sealDialog"
      @close="sealDialog = false"
      :orderIds="[orderId]"
    />

    <!-- Просмотр билетов -->
    <TicketModal
      v-if="viewingTicketsDialog"
      @close="viewingTicketsDialog = false"
      :tickets="ticketsByUser"
    />
    <!-- Журнал изменений заявки -->
    <History
      v-if="historyDialog"
      @close="historyDialog = false"
      @loading="historyLoading = !historyLoading"
      :orderId="orderId"
    />

    <!-- Список пассажиров -->
    <OrderPassangersModal
      :visible="passengersDialog"
      :rows="passengersRows"
      @close="passengersDialog = false"
    />

    <!-- Модалка согласования (для Админа/Логиста) -->
    <Modal
      v-if="osrApprovalDialog.isActive"
      @close="osrApprovalDialog.isActive = false"
      width="500px"
    >
      <h2 style="margin-bottom: 32px; text-align: center">Согласовать</h2>
      <div style="display: flex; flex-direction: column; gap: 24px">
        <Checkbox
          v-model="osrApprovalDialog.approveForOsr"
          :disabled="!infoData.isOsrRelated || infoData.osrVote !== null"
          :value="infoData.osrVote === true"
          label="Согласовать за ОСР"
        />
        <Checkbox
          v-model="osrApprovalDialog.approveForLeader"
          :disabled="infoData.status.id === 2"
          :value="infoData.status.id === 3"
          label="Согласовать за руководителя"
        />
      </div>
      <div style="margin-top: 32px; display: grid; gap: 16px">
        <Button
          :loading="osrApprovalDialog.loading"
          width="100%"
          height="48px"
          text="Согласовать"
          class="btn-primary"
          @click.native.prevent="submitOsrApproval"
        />
        <Button
          width="100%"
          height="48px"
          text="Отмена"
          class="btn-secondary"
          @click.native.prevent="osrApprovalDialog.isActive = false"
        />
      </div>
    </Modal>

    <!-- Модальное окно редактирования комментария -->
    <Modal
      v-if="editCommentDialog.isActive"
      @close="editCommentDialog.isActive = false"
      width="500px"
    >
      <h2 style="margin-bottom: 24px; text-align: center">
        Редактирование комментария
      </h2>

      <Form @request="updateCommentSubmit">
        <VInput
          v-model="editCommentDialog.comment"
          type="textarea"
          name="comment"
          placeholder="Введите текст комментария"
          style="margin-bottom: 24px; min-height: 120px"
          required
          minLength="3"
        />

        <Button
          :loading="editCommentDialog.loading"
          width="100%"
          height="48px"
          text="Сохранить"
          class="btn-primary"
          style="margin-bottom: 16px"
        />
        <Button
          width="100%"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          @click.native.prevent="editCommentDialog.isActive = false"
        />
      </Form>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<script>
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import VSelect from "@/components/Form/VSelect.vue";
import Checkbox from "@/components/Form/Checkbox.vue";
import Button from "@/components/Button.vue";
import Modal from "@/components/Modals/Modal.vue";
import VStatus from "@/components/VStatus.vue";
import AccountBadge from "@/components/AccountBadge.vue";
import VSwitch from "@/components/VSwitch.vue";
import AddPassengersModal from "@/views/Orders/AddPassengers.vue";
import TicketModal from "@/views/Orders/TicketModal.vue";
import Preloader from "@/components/Preloader.vue";
import History from "@/views/Orders/History.vue";
import SealModal from "@/components/Modals/SealModal.vue";
import HasPasOrderModal from "@/components/Modals/HasPasOrderModal.vue";
import NoVipModal from "@/components/Modals/NoVipModal.vue";
import OrderRelatedAccordion from "@/views/Orders/OrderRelatedAccordion";
import OrderPassangersModal from "@/components/Order/OrderPassangersModal.vue";

import {
  createOrder,
  getOrder,
  deleteOrder,
  updateOrder,
  markOrderAsViewed,
  markOrderAsUnviewed,
  addTickets,
  updateOrders,
  updateOrderLogist,
  deletePassengersFromOrder,
  getOrders,
  createComment,
  updateComment,
  deleteComment,
  approveOsr,
} from "@/api/orders.js";
import {
  parseDate,
  simpleDate as convertDate,
} from "@/utils/filters/dateFilters";
import { getHeads, getUserFromDepartament, getUserWithRole } from "@/api/users";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Point from "@/models/Order/Point";
import Direction from "@/models/Order/Direction";
import OrderRelated from "@/components/Order/OrderRelated";
import getPathOrder from "@/utils/Order/getPathOrder";
import { goToOrder } from "@/utils/router";

const USER_MODEL = "App\\Models\\User\\User";
const PASSENGER_MODEL = "App\\Models\\Passenger\\Passenger";

export default {
  components: {
    OrderRelated,
    Form,
    VInput,
    VSelect,
    Checkbox,
    Button,
    Modal,
    VStatus,
    AccountBadge,
    VSwitch,
    AddPassengersModal,
    TicketModal,
    Preloader,
    History,
    SealModal,
    OrderRelatedAccordion,
    HasPasOrderModal,
    NoVipModal,
    OrderPassangersModal,
  },
  data() {
    return {
      // значения форм
      infoData: {
        passengersFIO: [],
        isOsrApprovable: false,
        isOsrRelated: false,
        osrVote: null,
      },
      passengerReturn: [],
      routsReturn: [],
      leadReturn: [],
      returnReason: [],
      routs: [],
      returnDate: {},
      reasonComment: "",
      directions: [new Direction("Туда"), new Direction("Обратно")],
      deletePassengerList: [],
      deleteTransferList: [],

      // чекбоксы
      oneWay: true,
      roundtrip: false,
      withTransfer: false,
      isError: false,

      // модалки
      commentDialog: {
        isActive: false,
        title: "",
        submit: () => {},
      },
      addPassengerDialog: false,
      viewingTicketsDialog: false,
      sealDialog: false,
      historyDialog: false,
      passengersDialog: false,

      osrApprovalDialog: {
        isActive: false,
        approveForOsr: false,
        approveForLeader: true,
        loading: false,
      },

      // loaders
      getOrderLoading: true,
      loaders: {
        agreed: false,
        refusal: false,
        accept: false,
        complete: false,
        draft: false,
        modification: false,
      },
      saveLoading: false,
      reasonCommentLoading: false,
      setTicketsLoading: false,
      historyLoading: false,
      isHasTicket: false,

      leaders: [],
      passenger: [],

      returnOrdersData: [],

      hasOrders: [],
      pointsHistoryLoading: false,
      pointsHistory: {
        init: [],
        current: [],
      },
      points: [],
      isNoVip: false,
      // Вкладка комментариев
      isCommentsActive: false,
      comment: "",

      // Редактирование комментариев
      activeCommentMenu: null,
      editCommentDialog: {
        isActive: false,
        comment: "",
        commentId: null,
        loading: false,
      },

      // "Контроль СВП" в заявке
      isControl: false,
      // Просмотр заявки
      unviewed: false,
      // Отпечаток базового состояния маршрутов для сравнения при сохранении
      routeBaselineFingerprint: null,
      // Флаг, позволяющий выйти без проверки (кнопка «Отменить»)
      skipGuardForNextLeave: false,
    };
  },

  async mounted() {
    const { data } = await getUserWithRole(5);
    this.SET_LOGISTICIANS(data);

    getHeads().then((res) => (this.leaders = res.data || null));

    if (!this.isRead) this.getOrderLoading = false;

    if (this.isRead || this.isEdit) {
      await this.getOrder();
    }

    if (this.isCreate) {
      const defaultOsr = !!this.isOSRStaff;
      this.infoData.isOsrApprovable = defaultOsr;
      this.infoData.isOsrRelated = defaultOsr;
    }

    const response = await getUserFromDepartament();
    this.passenger = response.data.data;

    // Переключатель просмотренной заявки по умолчанию
    this.unviewed = false;
    // Отметить заявку просмотренной после монтирования
    if (this.orderId) {
      markOrderAsViewed(this.orderId);
    }

    window.addEventListener("beforeunload", this.prevent);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.prevent);
  },

  computed: {
    ...mapState("users", ["users", "activeUser", "logisticians", "passengers"]),
    ...mapState("options", [
      "transportOptions",
      "statusOptions",
      "expenseOptions",
      "priorityOptions",
    ]),
    ...mapState("returnReasons", ["returnReasons"]),
    ...mapGetters("users", [
      "isAdmin",
      "isSuperAdmin",
      "isLogist",
      "isLeader",
      "isOSRStaff",
      "usersWithFIO",
    ]),
    ...mapGetters("departments", ["getDepartmentNameById"]),
    ...mapGetters("filiations", ["getFiliationNameById"]),
    osrIconName() {
      if (!this.infoData?.isOsrRelated) {
        return null;
      }
      if (this.infoData.osrVote === true) {
        return "osr-accept";
      }
      if (this.infoData.osrVote === false) {
        return "osr-reject";
      }
      return "osr";
    },
    getRouts() {
      this.directions.forEach((item) => {
        if (item.fromData.town !== "") {
          let from = item.fromData;
          let to = "";
          let point = "";
          if (item.transfers.length) {
            item.transfers.forEach((transfer, i) => {
              if (i === 0) {
                to = transfer;
                point = {
                  id: item.fromData.id,
                  from: from.id,
                  fromTown: from.town,
                  to: to.id,
                  toTown: to.town,
                  name: from.town + " - " + to.town,
                };
                this.routs.push(point);
              }
              if (i >= 0 && i < item.transfers.length - 1) {
                from = item.transfers[i];
                to = item.transfers[i + 1];
                point = {
                  id: transfer.id,
                  from: from.id,
                  fromTown: from.town,
                  to: to.id,
                  toTown: to.town,
                  name: from.town + " - " + to.town,
                };
                this.routs.push(point);
              }
              if (i === item.transfers.length - 1) {
                from = transfer;
                to = item.toData;
                point = {
                  id: transfer.id,
                  from: from.id,
                  fromTown: from.town,
                  to: to.id,
                  toTown: to.town,
                  name: from.town + " - " + to.town,
                };
                this.routs.push(point);
              }
            });
          } else {
            to = item.toData;
            point = {
              id: item.fromData.id,
              from: from.id,
              fromTown: from.town,
              to: to.id,
              toTown: to.town,
              name: from.town + " - " + to.town,
            };
            this.routs.push(point);
          }
        }
      });
      return this.routs;
    },
    type() {
      return this.$route.params.type || "";
    },
    leadersExist() {
      if (!Array.isArray(this.leaders) || !this.leaders.length) {
        return [];
      }
      return this.leaders.filter((leader) => leader?.deleted_at === null);
    },
    logisticiansExist() {
      if (!Array.isArray(this.logisticians) || !this.logisticians.length) {
        return [];
      }
      return this.logisticians.filter(
        (logistician) => logistician.deleted_at === null
      );
    },
    orderId() {
      return this.$route.params.id || null;
    },
    isRead() {
      return this.type === "read";
    },
    isEdit() {
      return this.type === "edit";
    },
    isCreate() {
      return this.type === "create";
    },
    getIsError() {
      return this.isError;
    },
    isOwner() {
      return this.infoData?.userFIO?.id === this.activeUser?.id;
    },
    isPassenger() {
      return this.infoData.passengersFIO?.some(
        (user) => user.id === this.activeUser?.id
      );
    },
    showOsrSwitch() {
      const canManageOsr =
        this.isOSRStaff || this.isLogist || this.isAdmin || this.isSuperAdmin;
      if (this.isCreate) {
        return canManageOsr;
      }
      return this.infoData.isOsrApprovable === true;
    },
    hasOsrLeaderRoles() {
      return (
        this.isOSRStaff &&
        this.isLeader &&
        !this.isAdmin &&
        !this.isSuperAdmin &&
        !this.isLogist
      );
    },
    isPureOsr() {
      return (
        this.isOSRStaff &&
        !this.isLeader &&
        !this.isLogist &&
        !this.isAdmin &&
        !this.isSuperAdmin
      );
    },
    buttons() {
      const baseApprovalStatuses = [1, 7, 6, 8, 9];
      const osrApprovalStatuses = [1, 2, 6, 7, 8, 9];

      const canApproveStatus = baseApprovalStatuses.includes(
        this.infoData.status?.id
      );

      const canApproveOtherRoles =
        (this.isLeader || this.isLogist || this.isAdmin || this.isSuperAdmin) &&
        canApproveStatus;

      const canApproveOsr =
        this.isPureOsr &&
        this.infoData.isOsrRelated &&
        osrApprovalStatuses.includes(this.infoData.status?.id) &&
        this.infoData.osrVote === null;

      const canApproveOsrLeaderCombined =
        this.hasOsrLeaderRoles &&
        this.infoData.isOsrRelated &&
        osrApprovalStatuses.includes(this.infoData.status?.id) &&
        this.infoData.osrVote === null;

      const canRefuseLeader =
        this.isLeader &&
        (this.infoData.status?.id === 1 ||
          this.infoData.status?.id === 7 ||
          this.infoData.status?.id === 6);

      const canRefuseOtherRoles =
        (this.isLogist || this.isAdmin || this.isSuperAdmin) &&
        this.infoData.status?.id !== 3 &&
        this.infoData.status?.id !== 5;

      const canRefuseOsr =
        this.isPureOsr &&
        this.infoData.osrVote === null &&
        this.infoData.status?.id !== 3 &&
        this.infoData.status?.id !== 5;

      return [
        // для просмотра
        {
          show:
            this.isRead &&
            (canApproveOtherRoles ||
              canApproveOsr ||
              canApproveOsrLeaderCombined),
          event: () => this.agreeAction(),
          title: "Согласовать",
          loading: "agreed",
        },
        {
          show:
            this.isRead &&
            (canRefuseLeader || canRefuseOtherRoles || canRefuseOsr),
          event: () => this.openRefusalConfrimModal(),
          title: "Отказать",
          loading: "refusal",
        },
        {
          show:
            this.isRead &&
            (this.isLogist || this.isAdmin || this.isSuperAdmin) &&
            this.infoData.status?.id === 2,
          title: "Принять в работу",
          event: () => {
            this.changeStatus(4, "accept");
          },
          loading: "accept",
        },
        {
          show: this.isRead && this.infoData.status?.id === 5,
          event: () => this.openReturnOrderModal("обмен"),
          title: "Обмен",
        },
        {
          show: this.isRead && this.infoData.status?.id === 5,
          event: () => this.openReturnOrderModal("возврат"),
          title: "Возврат",
        },
        {
          show:
            this.isRead &&
            (this.isLogist || this.isAdmin || this.isSuperAdmin) &&
            this.infoData.status?.id === 4,
          event: () => this.changeStatus(7, "modification"),
          title: "На доработку",
          loading: "modification",
        },
        {
          show:
            this.isRead &&
            (this.isLogist || this.isAdmin || this.isSuperAdmin) &&
            (this.infoData.status?.id === 4 || this.infoData.status?.id === 5),
          event: () => (this.sealDialog = true),
          title: "Печать",
        },
        {
          show:
            this.isRead &&
            (this.isLogist || this.isAdmin || this.isSuperAdmin) &&
            (this.infoData.status?.id === 4 || this.infoData.status?.id === 5),
          event: () =>
            this.$router.push({
              name: "TicketsInfo",
              params: { backLink: this.$route.path },
            }),
          title: "Билеты",
        },
        {
          show: this.isRead,
          event: () => (this.viewingTicketsDialog = true),
          title: "Просмотреть билеты",
        },
      ];
    },
    ticketsByUser() {
      let allowedOrderTickets = [];

      this.infoData.passengersFIO?.forEach((user) => {
        allowedOrderTickets = [
          ...allowedOrderTickets,
          ...user.tickets,
          ...(user.passengers?.map(({ tickets }) => tickets) || []).flat(),
        ];
      });
      return allowedOrderTickets.filter((ticket) => !!ticket);
    },
    passengersRows() {
      return (this.infoData.passengersFIO || []).map((u) => {
        const fio = `${u.surname || ""} ${u.name || ""} ${
          u.patronymic || ""
        }`.trim();
        const department =
          u?.department?.name ||
          this.getDepartmentNameById(u?.department_id) ||
          "-";
        const filiation =
          u?.filiation?.name ||
          this.getFiliationNameById(u?.department_id) ||
          "-";
        return [fio || "-", department, filiation];
      });
    },
    leadActiveUser() {
      if (!this.leaders.length) return;
      return this.isCreate
        ? this.leaders?.find(
            (user) =>
              user.department_id === this.activeUser.department_id && user.head
          )
        : null;
    },
    trimUsersWithFIO() {
      const data = this.passenger?.filter(
        (user) =>
          !this.infoData.passengersFIO.some(
            (addedUser) => addedUser.id === user.id
          )
      );
      return data;
    },

    // связанные заявки
    ordersRelated() {
      if (this.infoData.parentId) {
        return [
          {
            id: this.infoData.parentId,
            number: this.infoData.parentNumber,
          },
        ];
      }

      if (this.returnOrdersData?.length) {
        return this.returnOrdersData.map((order) => ({
          id: order.history.order_id,
          number: "№ " + order.history.number,
        }));
      }

      return [];
    },
    orderRelatedType() {
      return this.infoData.parentId ? "parent" : "return";
    },
    isOrderReturn() {
      return this.infoData.parentId ? true : false;
    },
    orderRelatedAccordionTitle() {
      const statusName = this.infoData.status.name;
      return this.infoData.parentId
        ? `Создана из заявки ${
            this.infoData.parentNumber
          } на ${statusName.toLowerCase()}`
        : statusName;
    },

    ordersRelatedAccordion() {
      if (this.returnOrdersData?.length) return this.returnOrdersData;
      if (this.infoData.parentId) {
        const parent = this.infoData.parent;
        return [
          {
            history: {
              order_id: parent.id,
              number: parent.number,
              passengers: parent.passengers,
              paths: getPathOrder(parent.points),
            },
          },
        ];
      }
      return [];
    },

    isCommentsExists() {
      return this.infoData?.comments?.length;
    },

    // Проверка прав на редактирование комментариев
    canEditComment() {
      const roles = this.activeUser?.roles || [];
      return roles.some(
        (role) =>
          role.id === 1 || // administrator
          role.id === 5 || // logistician
          role.id === 6 // superadministrator
      );
    },

    // Проверяет, нужно ли блокировать переходы для заявки обмена
    disableExchangeNavigation() {
      return (
        this.isEdit &&
        this.isOrderStatusExchange &&
        this.infoData.parentId &&
        this.notUpdatedOrder
      );
    },

    isOrderStatusExchange() {
      return this.infoData.status?.id === 9;
    },

    isOrderStatusRefund() {
      return this.infoData.status?.id === 8;
    },

    notUpdatedOrder() {
      return (
        this.infoData.createDateOriginal === this.infoData.updateDateOriginal
      );
    },
  },

  methods: {
    ...mapActions("options", ["setSort"]),
    ...mapActions("options", ["setTab"]),
    agreeAction() {
      const canUseOsrDialog =
        this.isRead &&
        this.infoData.isOsrRelated &&
        (this.isLogist ||
          this.isAdmin ||
          this.isSuperAdmin ||
          this.hasOsrLeaderRoles);

      // Для админа/логиста с заявкой ОСР открываем модалку; иначе стандартное согласование
      if (canUseOsrDialog) {
        this.osrApprovalDialog.isActive = true;
        // По умолчанию руководитель включен, ОСР включаем, только если требуется и ещё не голосовали
        this.osrApprovalDialog.approveForOsr =
          this.infoData.osrVote === true || this.infoData.osrVote === null;
        this.osrApprovalDialog.approveForLeader =
          this.infoData.status?.id === 2 || this.infoData.status?.id === 1;
        return;
      }

      // Роль ОСР: управляет только osr_vote, статус не меняем
      if (this.isRead && this.isPureOsr) {
        if (!this.infoData.isOsrRelated) {
          this.$root.alert("Действие доступно только для заявок ОСР");
          return;
        }
        this.loaders.agreed = true;
        approveOsr(this.orderId, true, this.infoData.checksum)
          .then((res) => {
            if (res?.checksum) this.infoData.checksum = res.checksum;
            this.$root.alert("Заявка согласована ОСР");
            return this.getOrder();
          })
          .catch(() => this.getOrder())
          .finally(() => (this.loaders.agreed = false));
        return;
      }

      // Остальные роли: стандартное согласование статуса
      this.changeStatus(2, "agreed");
    },
    async doApproveOsr(vote) {
      // Прямые кнопки для роли ОСР
      try {
        const res = await approveOsr(
          this.orderId,
          vote,
          this.infoData.checksum
        );
        if (res?.checksum) this.infoData.checksum = res.checksum;
        this.$root.alert(
          vote ? "Заявка согласована ОСР" : "Заявка отклонена ОСР"
        );
        await this.getOrder();
      } catch (e) {
        this.$root.alert("Ошибка согласования ОСР");
        await this.getOrder();
      }
    },

    cancelEdit() {
      // Выходим без проверки «нет изменений», запрос на навигацию выполним сразу
      this.skipGuardForNextLeave = true;
      this.$router.push({ name: "Orders" });
    },
    async submitOsrApproval() {
      this.osrApprovalDialog.loading = true;
      const tasks = [];
      try {
        if (this.osrApprovalDialog.approveForLeader) {
          tasks.push(
            updateOrders([
              {
                order_id: +this.orderId,
                status_id: 2,
                checksum: this.infoData.checksum,
              },
            ])
          );
        }
        if (
          this.osrApprovalDialog.approveForOsr &&
          this.infoData.isOsrRelated &&
          this.infoData.osrVote === null
        ) {
          tasks.push(approveOsr(this.orderId, true, this.infoData.checksum));
        }
        const results = await Promise.all(tasks);
        const updated = results?.find((r) => r && r.checksum);
        if (updated?.checksum) this.infoData.checksum = updated.checksum;
        this.$root.alert("Заявка согласована");
        this.osrApprovalDialog.isActive = false;
        await this.getOrder();
      } catch (e) {
        this.$root.alert("Ошибка согласования");
        await this.getOrder();
      } finally {
        this.osrApprovalDialog.loading = false;
      }
    },
    goToOrder,
    ...mapMutations("users", ["SET_LOGISTICIANS", "SET_LEADERS"]),

    prevent(event) {
      if (!this.isRead) {
        event.preventDefault();
        event.returnValue = "";
      }
    },

    // Создание комментария в новой заявке с комментарием из модального окна обмена/возврата
    async onCreateComment() {
      if (!this.$router.currentRoute.query?.comment) return;
      if (this.infoData?.comments) return;
      const oldRoutes = this.$router.currentRoute.query?.routes;
      const newRouts = oldRoutes?.map((route) => {
        return route.map((id) => {
          const point = this.infoData.points.find(
            (point) => point.old_point_id === id
          );
          if (point) return point.id;
        });
      });
      await createComment(
        this.$router.currentRoute.query?.comment,
        this.$router.currentRoute.params.id,
        this.$router.currentRoute.query?.status,
        newRouts
      );
      this.getOrder();
    },
    // Формирование текста комментария при изменении данных в маршрутах
    getExchangeComment() {
      let comment = "";
      const pointsHistoryHandle = (mainKey = "init") => {
        this.pointsHistory[mainKey].forEach((point, index) => {
          Object.keys(point).forEach((key) => {
            if (key === "id" || key === "sort") return;
            let initValue =
              index > this.pointsHistory.init.length - 1
                ? ""
                : this.pointsHistory.init[index][key];
            let currentValue =
              index > this.pointsHistory.current.length - 1
                ? ""
                : this.pointsHistory.current[index][key];

            if (typeof initValue === "object") {
              initValue = initValue?.name ?? "";
            } else if (typeof initValue === "boolean") {
              initValue = "";
            }
            if (typeof currentValue === "object") {
              currentValue = currentValue?.name ?? "";
            } else if (typeof currentValue === "boolean") {
              currentValue = "";
            }

            if (initValue === currentValue) return;

            const initDirection = "Было";
            const currentDirection = "Стало";
            // const initDirection = initValue
            //   ? this.pointsHistory.init[index]?.direction
            //     ? "Обратно"
            //     : "Туда"
            //   : "";
            // const currentDirection = currentValue
            //   ? this.pointsHistory.current[index]?.direction
            //     ? "Обратно"
            //     : "Туда"
            //   : "";
            if (!initValue) {
              // initValue = "-";
              initValue = `${initDirection} -`;
            } else {
              initValue = `${initDirection} ${initValue}`;
            }
            if (!currentValue) {
              // currentValue = "-";
              currentValue = `${currentDirection} -`;
            } else {
              currentValue = `${currentDirection} ${currentValue}`;
            }
            // comment += `${initValue} ➔ ${currentValue}\n`;

            comment += `${initValue} ${currentValue}\n`;
          });
        });
      };
      if (this.pointsHistory.init.length >= this.pointsHistory.current.length) {
        pointsHistoryHandle();
      } else {
        pointsHistoryHandle("current");
      }
      return comment;
    },

    async saveOrder(type, newStatusId, redirect = true, callback) {
      // Останавливаем обмен/возврат без фактических правок
      if (this.guardNoChangesAlert()) return;
      this.saveLoading = true;
      /* --------- отправка запроса --------- */
      // данные заявки
      let {
        status,
        userFIO,
        comment,
        passengersFIO,
        leadFIO,
        logistFIO,
        checksum,
        contractId,
      } = this.infoData;

      if (this.returnDate.length) {
        passengersFIO = this.returnDate.passengersFIO;
      }

      const passengers = [];
      passengersFIO.forEach((user) => {
        if (
          user.pasName ||
          user.model === "App\\Models\\Passenger\\Passenger"
        ) {
          passengers.push({
            passenger_id: user.id,
            model_passenger: PASSENGER_MODEL,
          });
        } else {
          passengers.push({
            passenger_id: user.id,
            model_passenger: USER_MODEL,
          });
        }
      });

      try {
        if (this.isEdit || type === "update") {
          if (this.comment) {
            await createComment(
              this.comment,
              this.orderId,
              newStatusId || status?.id
            );
            this.comment = null;
          }

          // Отправка комментария об обмене
          const exchangeComment = this.getExchangeComment();
          if (exchangeComment) {
            await createComment(
              exchangeComment,
              this.orderId,
              newStatusId || status?.id
            );
          }

          await deletePassengersFromOrder(
            this.orderId,
            this.deletePassengerList
          );

          await updateOrder(
            this.orderId,
            status?.id,
            userFIO?.id,
            comment,
            this.points,
            passengers,
            null,
            leadFIO?.id ? leadFIO?.id : null,
            logistFIO?.id ? logistFIO?.id : null,
            this.reasonComment || null,
            this.deleteTransferList ? this.deleteTransferList : null,
            checksum,
            contractId,
            this.isControl,
            this.infoData.isOsrApprovable
          );

          const { fingerprint: updatedFingerprint } =
            this.buildNormalizedRouteSnapshot(false);
          // После успешного сохранения принимаем текущее состояние как базовое
          this.routeBaselineFingerprint = updatedFingerprint;

          // Отметить заказ непросмотренным
          if (this.unviewed) {
            markOrderAsUnviewed(this.orderId);
          }

          if (!this.isRead) this.$router.push({ params: { type: "read" } });
        } else if (this.isCreate) {
          const orderData = await createOrder(
            null,
            status?.id,
            userFIO?.id,
            comment,
            this.points,
            passengers,
            null,
            leadFIO?.id,
            logistFIO?.id,
            "",
            null,
            this.isControl,
            this.infoData.isOsrApprovable
          );

          if (this.comment && orderData?.data?.id >= 0) {
            await createComment(this.comment, orderData.data.id, status?.id);
          }

          if (redirect) {
            this.$router.push({
              name: "Orders",
              params: { withoutConfrim: true },
            });
          }
        }

        callback && callback();
      } catch (err) {
        Promise.reject(err);
      }
      this.saveLoading = false;
      this.isHasTicket = false;
      this.isNoVip = false;
    },

    async getOrder(createComment = true) {
      this.routs = [];
      this.initDirection();
      this.initComplexity();
      await getOrder(this.orderId)
        .then(async ({ data }) => {
          this.infoData = {
            number: data.number || data.id,
            parent: data.parent || null,
            parentId: data?.parent?.id,
            parentNumber: data?.parent?.number,
            createDate: convertDate(data.created_at),
            createDateOriginal: data.created_at,
            updateDateOriginal: data.updated_at,
            status: data.status,
            expense: data.expense,
            userFIO: data.user,
            leadFIO: data.supervisor
              ? { ...data.supervisor, roles: [{ id: 3 }] }
              : null,
            passengersFIO:
              data.passengers?.map((user) => {
                return {
                  ...user.person,
                  passengers: user.child,
                };
              }) || [],
            logistFIO: data.logistician
              ? { ...data.logistician, roles: [{ id: 5 }] }
              : null,
            comment: data.comment,
            // Преобразуем дату в формат dd.mm.yyyy hh:mm с учетом часового пояса и сортируем по убыванию
            comments: data.comments
              ?.map((comment) => {
                const commentDate = new Date(comment.created_at);
                const date = new Intl.DateTimeFormat("ru", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })
                  .format(new Date(commentDate))
                  .replace(",", "");
                return {
                  ...comment,
                  created_at_modified: date,
                };
              })
              .sort(
                (a, b) =>
                  new Date(b.created_at).getTime() -
                  new Date(a.created_at).getTime()
              ),
            points: data.points,
            checksum: data.checksum,
            contractId: data.contract_id,
            isControl: data.is_control,
            isOsrApprovable: data.is_osr_approvable,
            isOsrRelated: data.is_osr_related,
            osrVote: data.osr_vote,
          };

          this.isControl = this.infoData.isControl;

          if (this.infoData.parentNumber) {
            this.infoData.parentNumber = "№ " + this.infoData.parentNumber;
          }

          this.returnOrdersData = data.history;

          // объект с максимальным кол-вом пересадок - туда(0) и обратно(1)
          const pointsCount = data.points.reduce(
            (obj, point) => {
              if (point.direction && obj[1] < point.sort) {
                obj[1] = point.sort;
              } else if (obj[0] < point.sort) {
                obj[0] = point.sort;
              }
              return obj;
            },
            { 1: 0, 0: 0 }
          );

          data.points?.forEach((point) => {
            if (point.direction && !this.roundtrip) this.roundtrip = true;
            if (point.sort > 2 && !this.withTransfer) this.withTransfer = true;

            const time = point?.start_time;

            // туда(0) обратно(1)
            const directionIndex = point.direction ? 1 : 0;
            const initValue = {
              id: point.id,
              old_point_id: point.old_point_id,
              town: point.name,
              date: point.start_date ? convertDate(point.start_date) : null,
              time: time,
              service: point.priority,
              transport: point.transport,
              expense: point.expense,
              sort: point.sort,
            };

            switch (point.sort) {
              case 1:
                this.directions[directionIndex].fromData = initValue;
                break;
              case pointsCount[directionIndex]:
                this.directions[directionIndex].toData = initValue;
                break;
              default:
                this.directions[directionIndex].transfers.push(initValue);
            }
          });

          if (createComment) {
            await this.onCreateComment();
          }
        })
        .catch(() => {
          this.$router.push({
            name: "NotFound",
            params: { back: "/orders", withoutConfrim: true },
          });
        })
        .finally(() => {
          this.getOrderLoading = false;
        });
    },

    async deleteOrder() {
      await deleteOrder(this.orderId);
      this.$router.push({ name: "Orders", params: { withoutConfrim: true } });
    },

    initDirection() {
      this.directions = [new Direction("Туда"), new Direction("Обратно")];
    },

    initComplexity() {
      // сброс настроек сложности маршрута
      this.oneWay = true;
      this.withTransfer = false;
      this.deleteTransferList = [];
    },

    async changeStatus(statusId, loader) {
      if (loader) this.loaders[loader] = true;

      updateOrders([
        {
          order_id: +this.orderId,
          status_id: statusId,
          checksum: this.infoData.checksum,
        },
      ])
        .then(() => {
          if (statusId === 4) {
            this.infoData.logistFIO = this.activeUser;
            updateOrderLogist([
              {
                order_id: +this.orderId,
                logistician_id: this.infoData.logistFIO.id,
              },
            ]).finally(() => {
              this.loaders[loader] = false;
              this.getOrder();
            });
          } else this.getOrder();
          const text = `Заявка №${this.infoData?.number} ${
            this.statusOptions
              .find((status) => status.id === statusId)
              ?.name?.toLowerCase() || "обновлена"
          }`;
          this.$root.alert(text);
        })
        .finally(() => (this.loaders[loader] = false));
    },

    async setTickets() {
      this.setTicketsLoading = true;

      const users = this.$refs.usersTicket;
      try {
        for (let index = 0; index < users.length; index++) {
          const item = users[index];
          if (item.file && item.file instanceof File) {
            const isUser = this.infoData.passengersFIO?.some(
              (user) => user === item.user
            );
            const model = isUser ? USER_MODEL : PASSENGER_MODEL;
            const formData = new FormData();
            formData.append("ticket", item.file);
            formData.append("model_passenger", model);
            await addTickets(this.orderId, item.user?.id, formData);
          }
        }
      } catch (err) {
        Promise.reject(err);
      }

      this.getOrder();
      this.setTicketsLoading = false;
      this.ticketsControlDialog = false;
    },

    // открытие модалок
    openDeleteConfrimModal() {
      this.$root.confrim(
        "Вы точно хотите удалить этот элемент?",
        this.deleteOrder,
        "Удалить"
      );
    },

    openDeletePassenger(index) {
      const deletePassenger = async () => {
        const passengerId = this.infoData.passengersFIO[index].id;
        this.deletePassengerList.push({
          passenger_id: passengerId,
          model_passenger: USER_MODEL,
        });
        this.$delete(this.infoData.passengersFIO, index);
      };
      this.$root.confrim(
        "Вы точно хотите удалить пассажира?",
        deletePassenger,
        "Удалить"
      );
    },

    opendeleteTransfer(index, wayIndex) {
      const deleteTransfer = () => {
        const candidate = this.directions[wayIndex].transfers[index];
        if (Object.prototype.hasOwnProperty.call(candidate, "id")) {
          this.deleteTransferList.push(candidate.id);
        }
        this.$delete(this.directions[wayIndex].transfers, index);

        //устаовка новых сортировок
        this.directions[wayIndex].transfers.forEach((item, idx) => {
          item.sort = idx + 2;
        });
      };
      // const deleteTransfer = async () => this.$delete(this.directions[wayIndex].transfers, index);
      this.$root.confrim(
        "Вы точно хотите удалить пересадку?",
        deleteTransfer,
        "Удалить"
      );
    },

    openRefusalConfrimModal() {
      const confrimFunc = () => {
        // Роль ОСР: управляет только osr_vote, статус не меняем никогда
        if (this.isRead && this.isPureOsr) {
          if (!this.infoData.isOsrRelated) {
            this.$root.alert("Действие доступно только для заявок ОСР");
            return;
          }
          this.loaders.refusal = true;
          approveOsr(this.orderId, false, this.infoData.checksum)
            .then((res) => {
              if (res?.checksum) this.infoData.checksum = res.checksum;
              this.$root.alert("Заявка отклонена ОСР");
              return this.getOrder();
            })
            .catch(() => this.getOrder())
            .finally(() => (this.loaders.refusal = false));
          return;
        } else {
          // Прочие роли: стандартный отказ — смена статуса
          this.changeStatus(3, "refusal");
          return;
        }
      };
      const confirmText = this.isPureOsr
        ? "Вы действительно хотите отменить заявку ОСР?"
        : "Вы действительно хотите отменить заявку?";
      this.$root.confrim(confirmText, confrimFunc, "Да", "color: #FF4443;");
    },

    openReturnOrderModal(title) {
      // Возвращаем id статуса для обмена или возврата
      const statusId = title.includes("обмен") ? 9 : 8;
      const returnOrders = async () => {
        this.reasonCommentLoading = true;
        await this.returnOrderNew(statusId);
        this.commentDialog.isActive = false;
        this.reasonCommentLoading = false;
      };

      this.commentDialog = {
        title: `Заявка на ${title}`,
        type: title,
        statusId: statusId,
        comment: this.reasonComment,
        submit: returnOrders,
        isActive: true,
      };
    },

    // Обработчик маршрутов, может возвращать компоненты маршрутов или объекты маршрутов
    handlePoints(init = false, toConvert = false) {
      /* --------- данные маршрутов --------- */
      // туда
      const thereFrom = this.$refs?.fromData[0];
      const thereTo = this.$refs?.toData[0];
      let thereTransfers = [];

      // обратно
      let backFrom;
      let backTo;
      let backTransfers = [];

      // пересдаки туда
      if (this.withTransfer) {
        thereTransfers = this.$refs.thereTransfers?.map((point) => point) || [];
      }

      // установка данных обратно и пересадки обратно
      if (this.roundtrip) {
        backFrom = this.$refs.fromData[1];
        backTo = this.$refs.toData[1];

        if (this.withTransfer) {
          backTransfers = this.$refs.backTransfers?.map((point) => point) || [];
        }
      }

      /* --------- сбор данных маршрутов --------- */
      let points = [thereFrom, thereTo, ...thereTransfers, ...backTransfers];
      if (backFrom) points.push(backFrom);
      if (backTo) points.push(backTo);

      // При инициализации компонента сохраняем данные маршрутов
      const modifiedPoints = points.map(({ formData, name }) => {
        return {
          ...formData,
          direction: name.includes("back"),
        };
      });

      // Добавление маршрутов в историю при инициализации
      if (init) {
        this.pointsHistory.init = modifiedPoints;
      } else {
        this.pointsHistory.current = modifiedPoints;
      }

      // Не конвертируем маршруты без необходимости
      if (!toConvert) return points;

      // Конвертация маршрутов
      points = modifiedPoints.map((point) => {
        const {
          direction,
          town,
          expense,
          transport,
          service,
          date,
          time,
          sort,
          id,
        } = point;

        return new Point(
          town,
          direction,
          expense?.id,
          transport?.id,
          service?.id,
          sort,
          date ? parseDate(`${date} ${time}`) : null,
          time,
          id
        );
      });
      return points;
    },

    // Строит нормализованный снимок маршрутов и его отпечаток
    buildNormalizedRouteSnapshot(useInit = false) {
      // Берем подготовленные точки из pointsHistory (инициализационный снимок или текущий)
      const source = useInit
        ? this.pointsHistory.init
        : (() => {
            // Актуализируем текущие точки
            this.handlePoints(false, false);
            return this.pointsHistory.current;
          })();

      // Нормализация значений
      const normTown = (v) => (typeof v === "object" ? v?.name ?? "" : v ?? "");
      const idOf = (v) => (typeof v === "object" ? v?.id ?? null : v ?? null);
      const normDate = (v) => {
        if (!v) return null;
        const s = String(v);
        const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
        return m ? `${m[3]}-${m[2]}-${m[1]}` : s.slice(0, 10);
      };
      const normTime = (v) => {
        if (!v) return null;
        const s = String(v);
        return /^\d{2}:\d{2}$/.test(s) ? `${s}:00` : s;
      };

      const snapshot = (source || [])
        .map((p) => ({
          direction: p.direction ? "back" : "there",
          sort: Number(p.sort) || 0,
          town: normTown(p.town),
          expenseId: idOf(p.expense),
          transportId: idOf(p.transport),
          serviceId: idOf(p.service),
          date: normDate(p.date),
          time: normTime(p.time),
        }))
        // Учитываем активные настройки направления (в одну сторону / туда-обратно)
        .filter((item) => (this.roundtrip ? true : item.direction === "there"))
        // Упорядочиваем для стабильного сравнения
        .sort((a, b) =>
          a.direction === b.direction
            ? a.sort - b.sort
            : a.direction === "there"
            ? -1
            : 1
        );

      // Строим отпечаток
      const fingerprint = JSON.stringify(snapshot);
      return { snapshot, fingerprint };
    },

    // Гарантирует наличие baseline. Если его нет — пытается собрать из init,
    // иначе берёт текущие точки и фиксирует как базовый снимок.
    ensureRouteBaseline() {
      if (this.routeBaselineFingerprint) return this.routeBaselineFingerprint;
      const hasInit =
        Array.isArray(this.pointsHistory?.init) &&
        this.pointsHistory.init.length > 0;
      const { fingerprint } = this.buildNormalizedRouteSnapshot(hasInit);
      this.routeBaselineFingerprint = fingerprint;
      return this.routeBaselineFingerprint;
    },

    // Единый guard: если нет изменений для обмена/возврата — показать алерт и запретить действие
    guardNoChangesAlert() {
      if (
        this.isEdit &&
        this.infoData.parentId &&
        (this.isOrderStatusExchange || this.isOrderStatusRefund)
      ) {
        const { fingerprint } = this.buildNormalizedRouteSnapshot(false);
        const baseline = this.ensureRouteBaseline();
        if (fingerprint === baseline) {
          this.$root.alert("Для сохранения измените данные заявки");
          return true;
        }
      }
      return false;
    },

    checkOrders() {
      this.points = this.handlePoints();

      // проверка валидности
      let hasError = false;
      this.points.forEach((point) => {
        if (point.hasValidationErrors(["date", "time"])) hasError = true;
      });
      if (this.$refs.infoForm.hasValidationErrors()) hasError = true;
      if (hasError) return;
      if (!this.infoData.passengersFIO.length) {
        Promise.reject("Выберите пассажиров!");
        return;
      }

      // Останавливаем валидацию, если обмен/возврат не менялся
      if (this.guardNoChangesAlert()) return;

      // конвертация маршрутов
      // Инициализация false, конвертация true
      this.points = this.handlePoints(false, true);

      this.saveLoading = true;
      let dates = [];
      let userPassengerId = [];
      let chackedPassengers = [];
      this.hasOrders = [];
      let businessClass = false;
      let hasVip = true;

      this.points.forEach((point) => {
        if (point.start_date !== null) dates.push(point.start_date);
        if (point.priority_id === 3) businessClass = true;
      });

      this.infoData.passengersFIO.forEach((pas) => {
        if (!pas.is_vip) hasVip = false;
      });

      if (businessClass && !hasVip) {
        this.saveLoading = false;
        this.isNoVip = true;
      } else {
        if (dates.length > 0) {
          const mnDate = dates.reduce(function (a, b) {
            return a < b ? a : b;
          });
          const mxDate = dates.reduce(function (a, b) {
            return a > b ? a : b;
          });
          const startAtBetween = [mnDate, mxDate];

          this.infoData.passengersFIO.forEach((pas) => {
            if (pas.model === "App\\Models\\User\\User" || !pas.pasName) {
              userPassengerId.push(pas.id);
              chackedPassengers.push(pas);
            }
          });
          const params = {
            expand: "passengers",
            "search[StartAtBetween]": startAtBetween || null,
            "search[UserPassengerId]": userPassengerId || null,
          };

          getOrders(params).then((res) => {
            const orders = res.data.data.filter(
              (order) => order.id !== Number(this.orderId)
            );
            if (orders.length > 0) {
              orders.forEach((order) => {
                order.passengers.forEach((pas) => {
                  const hasOrderPas = chackedPassengers.find(
                    (user) => pas.person.id === user.id
                  );
                  if (hasOrderPas) {
                    this.hasOrders.push({
                      id: order.id,
                      number: order.number,
                      surname: hasOrderPas?.surname || "",
                      name: hasOrderPas?.name || "",
                      patronymic: hasOrderPas?.patronymic || "",
                    });
                  }
                });
              });
              this.saveLoading = false;
              this.isHasTicket = true;
            } else {
              this.saveOrder();
            }
          });
        } else {
          this.saveOrder();
        }
      }
    },
    async returnOrderNew(newStatusId, redirect = true, callback) {
      // Не создаём новую заявку, если данные маршрутов совпадают с исходными
      if (this.guardNoChangesAlert()) return;

      /* --------- данные маршрутов --------- */
      // туда
      const thereFrom = this.$refs.fromData[0];
      thereFrom.formData.direction = "there";
      const thereTo = this.$refs.toData[0];
      thereTo.formData.direction = "there";
      let thereTransfers = [];

      // обратно
      let backFrom;
      let backTo;
      let backTransfers = [];

      // пересдаки туда
      if (this.withTransfer) {
        thereTransfers =
          this.$refs.thereTransfers?.map((point) => {
            point.formData.direction = "there";
            return point;
          }) || [];
      }

      // установка данных обратно и пересадки обратно
      if (this.roundtrip) {
        backFrom = this.$refs.fromData[1];
        backFrom.formData.direction = "back";
        backTo = this.$refs.toData[1];
        backTo.formData.direction = "back";

        if (this.withTransfer) {
          backTransfers =
            this.$refs.backTransfers?.map((point) => {
              point.formData.direction = "back";
              return point;
            }) || [];
        }
      }

      /* --------- сбор данных маршрутов --------- */
      this.points = [thereFrom, thereTo, ...thereTransfers, ...backTransfers];
      if (backFrom) this.points.push(backFrom);
      if (backTo) this.points.push(backTo);

      let returnPoints = [];
      this.returnDate.routs.forEach((route) => {
        this.points.forEach((point) => {
          if (point.formData.id === route.from) returnPoints.push(point);
          if (point.formData.id === route.to) returnPoints.push(point);
        });
        returnPoints = returnPoints.filter((item, pos) => {
          return returnPoints.indexOf(item) === pos;
        });
      });

      const there = returnPoints.filter(
        (item) => item.formData.direction === "there"
      );
      const back = returnPoints.filter(
        (item) => item.formData.direction === "back"
      );

      // //сортировка точек
      var sortBySort = function (d1, d2) {
        return d1.formData.sort > d2.formData.sort ? 1 : -1;
      };

      there.sort(sortBySort);
      back.sort(sortBySort);

      //устаовка новых сортировок
      there.forEach((item, idx) => {
        item.formData.sort = idx + 1;
      });

      back.forEach((item, idx) => {
        item.formData.sort = idx + 1;
        if (there.length === 0) {
          if (item.formData.sort === 1) item.name = "thereFrom";
          else if (item.formData.sort === back.length + 1)
            item.name = "thereTo";
          else item.name = "thereTransfers";
        }
      });

      returnPoints = [...there, ...back];

      this.points = returnPoints;
      // конвертация маршрутов
      this.points = this.points.map(({ formData, name }) => {
        const { town, expense, transport, service, date, time, sort, id } =
          formData;
        const direction = name.includes("back");

        return new Point(
          town,
          direction,
          expense?.id,
          transport?.id,
          service?.id,
          sort,
          date ? parseDate(`${date} ${time}`) : null,
          time,
          id
        );
      });

      /* --------- отправка запроса --------- */
      // данные заявки
      const leadFIO = this.returnDate.leadFIO;

      const logistFIO = [];

      const comment = this.returnDate.comment;

      const passengersFIO = this.returnDate.passengersFIO;

      const passengers = [];
      passengersFIO.forEach((user) => {
        if (
          user.pasName ||
          user.model === "App\\Models\\Passenger\\Passenger"
        ) {
          passengers.push({
            passenger_id: user.id,
            model_passenger: PASSENGER_MODEL,
          });
        } else {
          passengers.push({
            passenger_id: user.id,
            model_passenger: USER_MODEL,
          });
        }
      });

      const parent_id = this.orderId;
      const paths = [];
      let newOrderId = null;
      this.returnDate.routs.forEach((item) => {
        const route = {
          from: item.fromTown,
          to: item.toTown,
        };
        paths.push(route);
      });

      const selectedRouts = this.routsReturn.map((route) => {
        return [route.from, route.to];
      });
      try {
        // Подставляем в комментарий причину обмена/возврата из селекта
        const reasonText = this.commentDialog.type.includes("обмен")
          ? "Обмен"
          : "Возврат";
        const modifiedReasonComment = this.returnReason?.name
          ? `${reasonText}, ${this.returnReason.name}, ${this.reasonComment}`
          : this.reasonComment
          ? `${reasonText}, ${this.reasonComment}`
          : reasonText;

        // Создание комментария в текущей заявке из модального окна обмена/возврата
        // await createComment(modifiedReasonComment, this.orderId, newStatusId, selectedRouts);

        // Сохранение текущей заявки
        // await this.saveOrder('update', newStatusId, true, callback);

        // При возврате не создаем новую заявку
        // if (this.commentDialog.type.includes("возврат")) {
        // await this.saveOrder('update', newStatusId, true, callback);
        // callback && callback();
        // this.$router.push('/orders');
        // return;
        // }

        // Создание новой заявки
        await createOrder(
          parent_id,
          newStatusId,
          this.activeUser?.id,
          comment,
          this.points,
          passengers,
          null,
          leadFIO?.id,
          logistFIO?.id,
          "",
          paths,
          this.isControl
        ).then((res) => {
          newOrderId = res.data.id;
        });

        // Редирект в новую заявку
        if (redirect) {
          this.isCommentsActive = false;
          this.$router.push({
            path: `/order/edit/${newOrderId}`,
            query: {
              comment: modifiedReasonComment,
              status: newStatusId,
              routes: selectedRouts,
            },
          });
        }
        callback && callback();
      } catch (err) {
        Promise.reject(err);
      }
    },

    selectReturnReason(data) {
      this.returnReason = data;
    },

    selectPassengerReturn(data) {
      this.passengerReturn = data;
    },

    selectRoutsReturn(data) {
      this.routsReturn = data;
    },

    selectleadReturn(data) {
      this.leadReturn = data;
    },

    // -----------------
    addTransfer(wayIndex) {
      const transfers = this.directions[wayIndex].transfers;
      const { town, date, time } = this.$refs.toData[wayIndex].formData;

      this.directions[wayIndex].transfers.push({ sort: transfers.length + 2 });
      this.$nextTick(() => {
        this.directions[wayIndex].toData = {
          town,
          date,
          time,
          sort: transfers.length ? transfers.length + 2 : 2,
        };
      });
    },

    autocomplete() {
      // туда
      const thereFrom = this.$refs.fromData[0];
      const thereTo = this.$refs.toData[0];
      let thereTransfers = [];
      this.points = [thereFrom, thereTo, ...thereTransfers];

      // проверка валидности
      this.points.forEach((point) => {
        if (point.hasValidationErrors()) this.isError = true;
        else this.isError = false;
      });
      if (this.isError) return;

      // Получение данных маршрутов "туда" для зеркального отображения в "обратно"
      const { formData: initBackFrom } = this.$refs?.fromData[0];
      const { formData: initBackTo } = this.$refs?.toData[0];

      const backFrom = {
        sort: 1,
        town: initBackTo?.town,
        transport: initBackFrom?.transport,
        expense: initBackFrom?.expense,
        service: initBackFrom?.service,
      };

      const backTo = {
        sort: 2,
        town: initBackFrom?.town,
      };

      this.$set(
        this.directions,
        1,
        new Direction("Обратно", [], backFrom, backTo)
      );
    },

    minDate(wayIndex, transferIndex, type = "date") {
      try {
        const { thereTransfers, backTransfers, fromData, toData } = this.$refs;
        const transfers = wayIndex === 0 ? thereTransfers : backTransfers;
        let transferBefore = null;

        if (transferIndex === undefined && transfers?.length) {
          transferBefore = transfers?.at(-1);
        } else if (transferIndex) {
          transferBefore = transfers?.at(transferIndex - 1);
        }

        let { formData } = transferBefore || (fromData || [])[wayIndex] || {};

        // валидация для time
        if (type !== "date") {
          const { formData: currentData } =
            (transferIndex !== undefined
              ? (transfers || [])[transferIndex]
              : (toData || [])[wayIndex]) || {};

          if (
            currentData?.date !== formData?.date ||
            formData?.date === undefined ||
            formData?.time === ""
          ) {
            return null;
          }
        }

        return formData && formData[type] ? formData[type] : new Date();
      } catch {
        console.error("ошибка в валидации даты");
        return null;
      }
    },

    addPassanger() {
      if (this.isOrderReturn) return;
      this.addPassengerDialog = true;
    },

    handleOrderClick(id) {
      if (this.isRead) {
        this.$router.push({ path: `/order/read/${id}` });
      } else if (this.disableExchangeNavigation) {
        this.$root.alert("Для перехода необходимо сохранить заявку на обмен");
      } else {
        this.$root.confrim(
          "Вы точно хотите покинуть эту страницу?",
          () => this.$router.push({ path: `/order/read/${id}` }),
          "Да"
        );
      }
    },

    // Блокирование полей для заявки обмена (только для уже существующих точек)
    disableExchangeFields(point) {
      return !!(
        this.isEdit &&
        this.isOrderStatusExchange &&
        this.infoData.parentId &&
        this.notUpdatedOrder &&
        point.old_point_id
      );
    },

    // Блокирование полей для заявки возврата (только для уже существующих точек)
    disableRefundFields(point) {
      return !!(
        this.isEdit &&
        this.isOrderStatusRefund &&
        this.infoData.parentId &&
        this.notUpdatedOrder &&
        point.old_point_id
      );
    },

    // Методы для редактирования комментариев
    toggleCommentActions(commentId) {
      this.activeCommentMenu =
        this.activeCommentMenu === commentId ? null : commentId;
    },

    openEditCommentModal(comment) {
      this.editCommentDialog = {
        isActive: true,
        comment: comment.comment,
        commentId: comment.id,
        loading: false,
      };
      this.activeCommentMenu = null;
    },

    async updateCommentSubmit() {
      this.editCommentDialog.loading = true;

      try {
        const updatedComment = await updateComment(
          this.editCommentDialog.commentId,
          this.editCommentDialog.comment
        );

        // Обновление комментария в списке
        const commentIndex = this.infoData.comments.findIndex(
          (c) => c.id === this.editCommentDialog.commentId
        );

        if (commentIndex !== -1) {
          // Обновляем комментарий с сохранением всех полей
          this.$set(this.infoData.comments, commentIndex, {
            ...this.infoData.comments[commentIndex],
            comment: this.editCommentDialog.comment, // Используем локальное значение
            updated_at: updatedComment.updated_at || new Date().toISOString(),
          });
        }

        this.editCommentDialog.isActive = false;
      } catch (error) {
        console.error("Ошибка редактирования комментария:", error);
      } finally {
        this.editCommentDialog.loading = false;
      }
    },

    deleteCommentConfirm(comment) {
      this.activeCommentMenu = null;
      this.$root.confrim(
        "Вы точно хотите удалить этот комментарий?",
        () => this.deleteCommentExecute(comment.id),
        "Удалить",
        "Отмена",
        "Комментарий будет удален"
      );
    },

    async deleteCommentExecute(commentId) {
      try {
        await deleteComment(commentId);

        // Удаление комментария из списка
        this.infoData.comments = this.infoData.comments.filter(
          (c) => c.id !== commentId
        );
      } catch (error) {
        console.error("Ошибка удаления комментария:", error);
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.isRead) {
      next();
      return;
    }
    const shouldSkipGuard = this.skipGuardForNextLeave;
    this.skipGuardForNextLeave = false;

    if (!shouldSkipGuard && this.guardNoChangesAlert()) return;

    this.$root.confrim(
      "Вы точно хотите покинуть страницу?",
      () => next(),
      "Покинуть",
      null,
      "Данные не будут сохранены"
    );
  },

  watch: {
    oneWay: {
      handler(val) {
        if (val) {
          this.roundtrip = false;
          // ресет формы "обратно"
          if (this.directions[1].fromData.id)
            this.deleteTransferList.push(this.directions[1].fromData.id);
          if (this.directions[1].toData.id)
            this.deleteTransferList.push(this.directions[1].toData.id);
          this.directions[1].transfers.map((transfer) => {
            if (transfer.id) this.deleteTransferList.push(transfer.id);
          });
          this.$refs.fromData[1].resetForm();
          this.$refs.toData[1].resetForm();
          this.$set(this.directions, 1, new Direction("Обратно"));
        }
      },
    },
    roundtrip: {
      handler(val) {
        if (val) {
          if (this.isError) {
            this.roundtrip = false;
            this.oneWay = true;
          } else {
            this.oneWay = false;
          }
        }
      },
    },
    withTransfer(val) {
      // сброс кол-во пересадок и нумерации сортировки points
      if (!val) {
        this.directions = this.directions.map((direction, i) => {
          direction.transfers.map((transfer) =>
            this.deleteTransferList.push(transfer.id)
          );
          const { town, date, time } = this.$refs.toData[i].formData;
          return {
            ...direction,
            transfers: [],
            toData: {
              town,
              date,
              time,
              sort: 2,
            },
          };
        });
      }
    },
    type() {
      this.getOrder();
    },
    "commentDialog.isActive"(val) {
      if (!val) this.reasonComment = "";
    },
    async "$route.params.id"() {
      this.pointsHistoryLoading = true;
      await this.getOrder(false);
      this.pointsHistoryLoading = false;
    },
    isEdit: {
      handler(value) {
        if (!value) return;
        this.pointsHistoryLoading = true;
        setTimeout(() => {
          this.handlePoints(true);
          this.pointsHistoryLoading = false;
          const { fingerprint } = this.buildNormalizedRouteSnapshot(true);
          this.routeBaselineFingerprint = fingerprint;
        }, 3000);
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.application {
  display: grid;
  grid-template-columns: 24% 57% 15.8%;
  column-gap: 17px;

  .panel,
  .info,
  .direction {
    display: flex;
    flex-direction: column;
    width: 100%;

    hr {
      width: calc(100% + 56px);
    }
  }

  .info {
    padding: 38px 28px;
    box-shadow: 0px 8px 8px rgba(0, 32, 51, 0.04),
      0px 12px 28px rgba(0, 32, 51, 0.12);
    border-radius: 4px;

    @media screen and (max-width: 1500px) {
      padding: 28px 12px;
    }

    .info_form {
      row-gap: 12px;
      margin-top: 32px;

      @media screen and (max-width: 1500px) {
        margin-top: 24px;
      }

      hr {
        margin: 0px -28px;
        width: calc(100% + 56px);

        @media screen and (max-width: 1500px) {
          width: calc(100% + 26px);
          margin: 0px -12px;
        }
      }

      .info_form-users {
        display: grid;
        max-height: 582px;
        margin-right: -13px;
        row-gap: 16px;
        margin-top: 16px;

        .user__item {
          position: relative;
          display: flex;
          width: 100%;
          padding: 0px 12px 15px 12px;
          background: rgba(0, 66, 105, 0.05);

          .user__item-icon {
            position: absolute;
            right: 6px;
            top: 12px;
            fill: $dark-gray;
            transition: 0.2s;

            &:hover {
              fill: $red;
            }
          }
        }
      }

      .user__add-button {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        border: 1px solid $gray;
        color: $gray;
        padding: 0 0 0 13px;

        .user__add-button-icon {
          fill: $blue;
          border-left: 1px solid $gray;
          border-radius: 0;
        }
      }
    }

    h1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .open-view-icon {
      margin-left: auto;
    }
  }

  .content {
    padding: 38px 28px;
    background: #f7f9f9;
    border-radius: 4px;
    position: relative;
    &__control {
      display: flex;
      align-items: center;
      gap: 25px;
      margin-right: 60px;
      padding-bottom: 14px;
      color: $dark-gray;
      white-space: nowrap;
    }
    &__item {
      position: relative;
      font-size: 18px;
      line-height: 48px;
      cursor: pointer;
      user-select: none;
      transition: 0.2s;

      &:hover {
        color: $blue;
      }

      &.active {
        color: $black;
        &::after {
          content: "";
          position: absolute;
          top: calc(100% + 4px);
          display: flex;
          width: 100%;
          border: 2px solid $blue;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
      }
    }

    &__edit {
      display: flex;
      column-gap: 6px;
      position: absolute;
      right: 0;
    }
  }

  .direction {
    .direction__complexity {
      margin-top: 32px;

      .direction__complexity-form {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
        column-gap: 12px;

        .form__checkbox {
          margin-right: 24px;
        }

        .complexity__read-item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 287px;
          height: 38px;
          color: $dark-gray;
          background: $light-gray;
          border-radius: 4px;
        }
      }
    }

    .direction__content {
      display: flex;
      column-gap: 12px;
      padding-top: 34px;

      .direction__content-point {
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        max-width: calc(50% - 6px);

        &:first-of-type {
          .point__item {
            background: #cce6fc;
          }
        }

        &:not(:first-of-type):last-of-type {
          .point__item {
            background: #d2dcee;
          }
        }

        .point__item {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          border-radius: 4px;
          padding: 20px;
          row-gap: 12px;
          position: relative;
          border: 1px solid transparent;

          @media screen and (max-width: 1500px) {
            padding: 12px;
          }

          &.disabled {
            background: none !important;
            border: 1px solid $gray;
          }
        }

        .mobile__item {
          @media screen and (max-width: 1500px) {
            width: 100% !important;
          }
        }

        .transfer__item:not(:last-child) {
          margin-bottom: 12px;
        }
      }
    }

    .direction__date {
      display: flex;
      justify-content: space-between;
      width: 100%;

      &--mobile {
        @media screen and (max-width: 1500px) {
          flex-direction: column;
          row-gap: 12px;
        }
      }
    }
  }

  .comments {
    margin-top: 32px;
    &__empty {
      text-align: center;
      color: $dark-gray;
    }
    .comment {
      padding: 16px;
      margin-top: 20px;
      box-shadow: 0px 8px 8px rgba(0, 32, 51, 0.04),
        0px 12px 28px rgba(0, 32, 51, 0.12);
      background: #ffffff;
      &__title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .profile {
          padding: 0;
          &__name {
            font-size: 19px;
          }
        }
      }
      &__date {
        color: $dark-gray;
        text-wrap: nowrap;
      }
      &__status {
        width: fit-content;
        margin-top: 12px;
      }
      &__message {
        margin-top: 5px;
        line-height: 24px;
        font-size: 16px;
        color: $black;
        white-space: break-spaces;
        overflow-x: hidden;
      }
    }
  }

  .panel {
    gap: 12px;
  }
}

.users__modal {
  max-height: 386px;
  margin: 8px -13px 8px 0;
  width: auto;

  .user__item {
    padding: 24px 0;

    &:not(:last-of-type) {
      border-bottom: 2px solid $light-gray;
    }
  }
}

.transfer {
  &__clear-icon {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 30px !important;
    height: 30px !important;
    fill: #536d86;

    @media screen and (max-width: 1500px) {
      top: 0;
    }

    &:hover {
      fill: $red;
    }
  }
}

.comment__actions {
  position: absolute;
  bottom: 8px;
  right: 16px;

  &-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 120px;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 16px;
    animation: fadeIn 0.15s ease-out;

    .buttons__item {
      height: 48px;
      color: #006fba;
    }

    .comment__action-item {
      align-items: start;
      height: 48px;
      color: #97b2c4;
    }
  }
  .buttons__actions {
    padding: 0;
    fill: #97b2c4;
    color: #97b2c4;
  }
}

.center {
  text-align: center;
}
</style>
